export const navigationLocal = {
  id: {
    welcome: "Halo",
    logout: "Keluar",
  },
  en: {
    welcome: "Hello",
    logout: "Logout",
  },
};

export const loginLocal = {
  id: {
    title: "Masuk untuk menggunakan Aplikasi",
    password: "Kata Sandi",
  },
  en: {
    title: "Login for using application",
    password: "Password",
  },
};
